import { useCallback, useContext, useEffect, useState } from "react";
import axios from "../../../../api/axios";
import { sleep } from "../../../../functions";
import { useNavigate } from "react-router-dom";
import useAlert from "../../../../globalComponents/useAlerts";

export default () => {
  const { showLoading, showAlert, dismissLoading } = useAlert();
  const [loading, setLoading] = useState(true);

  const [availableProducts, setAvailableProducts] = useState([]);

  const getAvailableProducts = useCallback(async () => {
    try {
      const { data: response } = await axios.get("/products?limit=1000");

      setAvailableProducts(
        response.data.map((p) => ({
          id: p._id,
          label: `${p.title}`,
          ...p,
        })) || [],
      );
    } catch (err) {
      showAlert({
        title: "Erro",
        description:
          "Não foi possível obter produtos disponíveis. Verifique os parâmetros enviados e tente novamente.",
      });
    }
  }, []);

  useEffect(() => {
    Promise.all([getAvailableProducts()]);
  }, []);

  return {
    loading,
    availableProducts,
    //availableProducts,
  };
};
